module.exports = __webpack_public_path__ + "img/life-preserver.c5f49168.svg";